import { MouseEvent, useCallback, useMemo, useState } from 'react';

const useFilterState = (
  initialValue: string,
  onApplyFilter: (value: string) => void,
  onClearFilter: () => void
) => {
  const [value, setValue] = useState(initialValue);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = useCallback((event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  }, []);

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const applyFilter = useCallback(() => {
    onApplyFilter(value);
    handleClose();
  }, [handleClose, onApplyFilter, value]);

  const clearFilter = useCallback(() => {
    onClearFilter();
    setValue('');
    handleClose();
  }, [handleClose, onClearFilter, setValue]);

  const isApplied = useMemo(() => !!initialValue, [initialValue]);

  return {
    open,
    handleClick,
    value,
    setValue,
    handleClose,
    anchorEl,
    isApplied,
    applyFilter,
    clearFilter,
  };
};

export default useFilterState;
